/**
 * Conversions between the browser's `datetime-local` value and the epoch **seconds**
 * galaxy's scheduled-maintenance API takes.
 *
 * Shared by the migration form and the standalone window card, which is why these live
 * apart from either.
 */

const LOCAL_DATETIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;

export const toEpochSeconds = (localValue: string): number | null => {
  // Shape-checked before parsing, not just NaN-checked. `new Date('2026-10-01')` is a
  // perfectly valid Date — anchored to UTC midnight rather than local — so a date-only
  // value would shift the window by the operator's offset, silently and by up to 14 hours.
  // `<input type="datetime-local">` always emits the full form; a paste or assistive
  // tooling need not.
  if (!LOCAL_DATETIME.test(localValue)) return null;
  const ms = new Date(localValue).getTime();
  return Number.isNaN(ms) ? null : Math.floor(ms / 1000);
};

/** The inverse, for prefilling an input. `toISOString` is UTC, so build it by parts. */
export const toLocalInputValue = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

/** Epoch seconds rendered in the operator's own timezone. */
export const formatEpochSeconds = (seconds: number) => new Date(seconds * 1000).toLocaleString();
